var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToggleRight = function SvgToggleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.823 4.812a7.188 7.188 0 0 1 0 14.376H9.176a7.188 7.188 0 0 1 0-14.376zm-5.647 1.2a5.989 5.989 0 0 0 0 11.976h5.647a5.99 5.99 0 0 0 0-11.976zm5.647 2.664a3.324 3.324 0 1 1-.002 6.647 3.324 3.324 0 0 1 .002-6.647m0 1a2.324 2.324 0 1 0 0 4.647 2.324 2.324 0 0 0 0-4.647"
  })));
};
export default SvgToggleRight;